import { useState } from 'react';

import buildPipelineRecordRef from 'app/audit-logs/buildPipelineRecordRef';

import { usePipelinePageContext } from './PipelinePageContextProvider';

export default function usePipelineAuditLogModal() {
  const { pipeline } = usePipelinePageContext();
  const [open, setOpen] = useState(false);

  return {
    open,
    openModal: () => setOpen(true),
    closeModal: () => setOpen(false),
    recordRef: buildPipelineRecordRef(pipeline),
  };
}
